import { Checkbox, Grid } from '@mantine/core';
import FormHeading from 'apps/Projects/SamplePlans/FormInputs/FormHeading';

import { NO_REGISTRY_STANDARD, REGISTRY_OPTIONS } from 'constants/projects';

import { SamplePlanRegistryV2Type } from 'store/projects/types';
import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations, useUpdateFormsFromConfig } from '../hooks';
import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

const RegistryDetails = () => {
  const samplePlanForm = useSamplePlanFormContext();
  const translations = useProjectsTranslations();
  const { registry_list } = samplePlanForm.getValues();

  // Ensure the form is updated with the latest config values
  useUpdateFormsFromConfig();

  const registryOptions: { value: string; label: string }[] = REGISTRY_OPTIONS.map((option) => ({
    value: option,
    label: option,
  }));

  const updateRegistries = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: SamplePlanRegistryV2Type,
  ) => {
    const isChecked = event.currentTarget.checked;
    let newRegistries: SamplePlanRegistryV2Type[];

    if (value === NO_REGISTRY_STANDARD) {
      newRegistries = isChecked ? [NO_REGISTRY_STANDARD] : [];
    } else {
      const baseRegistries = registry_list.filter((r) => r !== NO_REGISTRY_STANDARD);
      if (isChecked) {
        newRegistries = [...baseRegistries.filter((r) => r !== value), value];
      } else {
        newRegistries = baseRegistries.filter((r) => r !== value);
      }
    }
    samplePlanForm.setFieldValue('registry_list', newRegistries);
  };

  return (
    <>
      <FormHeading text={translations.complaintRegistriesQuestion} mb="xs" />
      <Grid columns={24}>
        {registryOptions.map(({ value, label }) => (
          <InputAndLabelGridRow
            elemId="registry-select"
            label={label}
            key={value}
            span={8}
            input={
              <Checkbox
                id={`registry-check-${value}`}
                checked={registry_list.includes(value)}
                onChange={(event) => updateRegistries(event, value)}
                type="checkbox"
              />
            }
          />
        ))}
      </Grid>
    </>
  );
};

export default RegistryDetails;
